<script lang="ts">
    import type {SearchHistoryEntryDto} from 'typings/portaro.be.types';
    import {getDateFormatter, getLocalization} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import {pipe} from 'core/utils';
    import KpClassicTable from 'shared/ui-widgets/table/classic/KpClassicTable.svelte';
    import KpButtonStyleAnchor from 'shared/ui-widgets/button/KpButtonStyleAnchor.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();
    const pageContext = getPageContext<SearchHistoryEntryDto[]>();
    const searchHistory = pageContext.staticData;
</script>

<div class="search-history-table-part">
    <KpClassicTable additionalClasses="search-history-table"
                    colorAccented
                    horizontallyDivided
                    responsive
                    bordered
                    verticallyCentered
                    horizontallyCentered
                    columnHeadersCentered>

        <tr slot="header">
            <th>{localize(/* @kp-localization hledani.DatumVyhledani */ 'hledani.DatumVyhledani')}</th>
            <th>{localize(/* @kp-localization hledani.VyhledavanyDotaz */ 'hledani.VyhledavanyDotaz')}</th>
            <th>{localize(/* @kp-localization hledani.PocetVyhledanychZaznamu */ 'hledani.PocetVyhledanychZaznamu')}</th>
            <th>{localize(/* @kp-localization commons.hledat */ 'commons.hledat')}</th>
        </tr>

        <svelte:fragment slot="body">
            {#each searchHistory as query}
                <tr>
                    <td>{pipe(query.date, dateFormatter('d.M.yyyy HH:mm'))}</td>
                    <td>
                        <samp>
                            <small>{query.title}</small>
                        </samp>
                    </td>
                    <td>{query.totalElements}</td>
                    <td>
                        <KpButtonStyleAnchor href="{query.url}">
                            <IconedContent icon="search">
                                {localize(/* @kp-localization commons.hledat */ 'commons.hledat')}
                            </IconedContent>
                        </KpButtonStyleAnchor>
                    </td>
                </tr>
            {/each}

            {#if searchHistory.length === 0}
                <tr>
                    <td class="empty-cell-container" colspan="4">
                    <span class="text-muted">
                        {localize(/* @kp-localization commons.NoRecordFound */ 'commons.NoRecordFound')}
                    </span>
                    </td>
                </tr>
            {/if}
        </svelte:fragment>
    </KpClassicTable>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .empty-cell-container {
        text-align: center;
        vertical-align: middle;
        padding: @spacing-m @spacing-ml;
    }
</style>